import styled from 'styled-components'
import Rating from '@material-ui/lab/Rating';

/*********** this is Styles Course Component *********/

export const CoursItem = styled.div`
    margin-bottom: 20px;
    border: 1px solid #e5e5e5;
    background-color: white;
    img{
        width: 100%;
        height: 180px;
    }
    hr{
        margin: 7px 0px;
    }
`;

export const CoursText = styled.div`
    padding: 18px 20px 1px;
    a{
        font-weight: 700;
        color: black;
        :hover{
        text-decoration:underline;
        color: var(--primaryColor);
    }
    }
    > p{
        color: #676767;
        font-size: 13px;
        margin-bottom: 10px;
    }
    `;

export const CoursInfo = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const MyRating = styled(Rating)`
    font-size: 18px !important;
`;

export const CoursInfoItem = styled.div`
    i , span{
        font-size: 14px;
        color: #55585a;
    }
    i{
        margin: 0px 4px;
        color: var(--primaryColor);
    }
`;

export const Flex = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const AuthorInfo = styled.div`
    padding: 1px 20px 18px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    img{
        width: 40px!important;
        height: 40px!important;
        border-radius: 50%;
        margin-right: 10px;
        box-shadow: 0 4px 8px 0 rgb(0 0 0 / 20%), 0 6px 20px 0 rgb(0 0 0 / 19%);
        border: 1px solid white;
    }
    >div span{
        font-size: 12px;
    }
`;

export const Btndate = styled.div`
    text-align: center;
    p{
        font-size: 11px;
        margin-bottom: 5px;
    }
    `;
export const FreeBtn = styled.div`
    padding: 1px 9px;
    background-color: var(--primaryColor);
    font-size: 12px;
    margin: 0 AUTO;
    display: inline-block;
    color: white;
`;
/*********** this is Styles Course Component *********/
